import { ASSESSMENTS_LOGIN_FAILURE_REASONS } from './constants';

export enum AssessmentsPendoEventType {
  LOGIN_PAGE_VIEWED = 'ASSESSMENTS_LOGIN_PAGE_VIEWED',
  LOGIN_SUCCEEDED = 'ASSESSMENTS_LOGIN_SUCCEEDED',
  LOGIN_FAILED = 'ASSESSMENTS_LOGIN_FAILED',
}

export type AssessmentsLoginFailureReason =
  (typeof ASSESSMENTS_LOGIN_FAILURE_REASONS)[keyof typeof ASSESSMENTS_LOGIN_FAILURE_REASONS];

// Only non-sensitive ids and outcomes: never credentials, names, tokens or error messages
interface AssessmentsPendoEventPayload {
  eventType: AssessmentsPendoEventType;
}

export interface LoginPageViewedEvent extends AssessmentsPendoEventPayload {
  eventType: AssessmentsPendoEventType.LOGIN_PAGE_VIEWED;
}

export interface LoginSucceededEvent extends AssessmentsPendoEventPayload {
  eventType: AssessmentsPendoEventType.LOGIN_SUCCEEDED;
  assessmentsId: string;
  activityId: string;
}

export interface LoginFailedEvent extends AssessmentsPendoEventPayload {
  eventType: AssessmentsPendoEventType.LOGIN_FAILED;
  reason: AssessmentsLoginFailureReason;
  status?: string;
}

export type AssessmentsPendoTrackEventPayload =
  | LoginPageViewedEvent
  | LoginSucceededEvent
  | LoginFailedEvent;
